import { Component } from '@angular/core';

@Component({
  selector: 'uni-main-container',
  templateUrl: './uni-main-container.component.html',
  styleUrls: ['./uni-main-container.component.scss']
})
export class UniMainContainerComponent {}
